import { useFeatureFlags } from '../../hooks';
import { ActivityPeriodTimeSetting } from './activityPeriodTimeSetting';
import { ActivityPeriodTimeSettingLegacy } from './activityPeriodTimeSettingLegacy';

/**
 * Chooses between the configurable workday selector and the pre-DS-3846 one.
 *
 * The activity question is rendered from two places, questionBuilder for a
 * standalone question and tableQuestionBuilder for one nested in a repeatable.
 * Reading the flag in each of them means a later edit can update one and forget
 * the other, which is precisely how the table path shipped ungated. Keeping the
 * decision here makes the two render sites structurally unable to disagree.
 *
 * When CustomWorkdayDuration is removed, delete this file and let both callers
 * mount ActivityPeriodTimeSetting directly.
 */

interface ActivityPeriodTimeSettingSwitchProps {
  questionId: string;
  startTime: string;
  workingTime: string;
  intervalDefault: string;
  onActivityPeriodTimeSettingChange: (
    id: string,
    value: string,
    action: string,
    tableId?: string,
  ) => void;
  tableId?: string;
  /** Only the configurable selector can be left incomplete, so only it needs it. */
  showValidationErrors?: boolean;
}

export const ActivityPeriodTimeSettingSwitch = ({
  questionId,
  startTime,
  workingTime,
  intervalDefault,
  onActivityPeriodTimeSettingChange,
  tableId,
  showValidationErrors = false,
}: ActivityPeriodTimeSettingSwitchProps) => {
  const { checkFlag } = useFeatureFlags();

  if (!checkFlag('CustomWorkdayDuration')) {
    return (
      <ActivityPeriodTimeSettingLegacy
        questionId={questionId}
        tableId={tableId}
        onActivityPeriodTimeSettingChange={onActivityPeriodTimeSettingChange}
        startTime={startTime}
        workingTime={workingTime}
        intervalDefault={intervalDefault}
      />
    );
  }

  return (
    <ActivityPeriodTimeSetting
      questionId={questionId}
      tableId={tableId}
      onActivityPeriodTimeSettingChange={onActivityPeriodTimeSettingChange}
      startTime={startTime}
      workingTime={workingTime}
      intervalDefault={intervalDefault}
      showValidationErrors={showValidationErrors}
    />
  );
};
